import AnimaticStoryBase from './AnimaticStoryBase';
import {
  LOCATION_USA,
  LOCATION_FRANCE,
  LOCATION_ROMANIA,
  LOCATION_SOUTHAFRICA,
  LOCATION_TURKEY,
  LOCATION_UAE,
  LOCATION_UK,
} from '../constants/AppConstants';
import ScreenOverlayStoryContinues from '../ui/overlays/ScreenOverlayStoryContinues';

/*
  These could probaby be flattened into AnimaticStoryBase with params,
  But I have a feeling they'll need some bespoke stuff, so leaving as seperate class
*/
export default class AnimaticStoryIntro extends AnimaticStoryBase {
  init({ watched, locationid = LOCATION_USA }) {
    this.watched = watched;
    this.assets = 'location';
    this.extraAssets = ['location_train'];
    switch (locationid) {
      case LOCATION_USA:
      case LOCATION_FRANCE:
        this.extraAssets = ['location_boat'];
        break;
      case LOCATION_ROMANIA:
        this.extraAssets = ['location_train'];
        break;
      case LOCATION_SOUTHAFRICA:
      case LOCATION_UAE:
      case LOCATION_UK:
        this.extraAssets = ['location_plane'];
        break;
      case LOCATION_TURKEY:
        this.extraAssets = ['location_bus'];
        break;
    }
  }

  handleComplete() {
    this.game.gameController.triggerWorldState();
  }
}



// WEBPACK FOOTER //
// ./js/app/states/AnimaticStoryLocation.js